import { doPost } from './common'

export const start = (breakId, stepId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    stepType: 'filter',
  }

  return doPost(`/filter/start`, payload)
}

export const complete = (breakId, stepId, stepSkipped) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    skipped: stepSkipped,
  }

  return doPost(`/filter/complete`, payload)
}
